import axios from 'axios'
import $store from '@/store'
import {
  camelCaseKeys,
  // snakeCaseKeys
} from '@/util'
import { setError } from './proxyErrorParser'

const _axios = axios.create({
  baseURL: `${$store.state.env.baseURL}`
})

_axios.interceptors.request.use(config => {
  $store.dispatch('loading/setIsLoading', true)
  if (config.headers.Authorization == null) {
    let token = localStorage.getItem($store.state.env.token.name)
    if (token != null) {
      config.headers.Authorization = `JWT ${token}`
    }
  }
  return config
}, error => {
  // Do something with request error
  $store.dispatch('loading/setIsLoading', false)
  return Promise.reject(error)
})

const ignoreCaseTransform = ['/codes']

_axios.interceptors.response.use(
  (resp) => {
    // 응답 객체 가공 무시
    if (ignoreCaseTransform.includes(JSON.parse(resp.config.data).url)) {
      return Promise.resolve(resp)
    }

    return Promise.resolve(camelCaseKeys(resp))
  },
  async (error) => {
    const { response } = error
    if (response?.status === 403) {
      $store.dispatch('auth/signout')
    }

    const errorResponse = setError(response)
    console.log(errorResponse, errorResponse.status)
    if (errorResponse.status === 400) {
      window.$swal.fire({
        icon: 'error',
        html: errorResponse.message,
        confirmButtonText: '확인'
      })
    }
    return Promise.reject(camelCaseKeys(errorResponse))
  },
)

function get(url) {
  return proxy('GET', url)
}
function del(url) {
  return proxy('DELETE', url)
}
function put(url, body) {
  return proxy('PUT', url, body)
}
function post(url, body) {
  return proxy('POST', url, body)
}

function proxy(method, url, body = {}) {
  return _axios.post('/fundanow-gateway/proxy/', {
    method,
    url,
    body,
  })
}

export default { get, put, post, del }
